import React, { Component } from 'react';

// COMPONENTS
import { Trans } from '@lingui/macro';
import CartList from '../../../containers/CartList';
import Row from '../../../components/Row';
import { Typography, Button, Card, CartPlansCredit, Column } from 'components';

class Details extends Component {
  state = {
    currentCredit: 1,
    expiryDate: new Date(),
    totalCredits: 3,
    isFirstSchedule: false,
    appointmentCategory: 'Agendamento',
    itemList: [
      {
        date: "20/12/2019",
        duration: "45",
        id: "524",
        time: "19:00",
        weekday: "Sexta-Feira",
      },
    ],
    professionalName: 'Psicóloga Gisella Moura Fadda',
  }

  handleDeleteItem = () => {
    alert('delete item function');
  }

  handleSubmit = () => {
    alert('submit order');
  }

  render() {
    const {
      currentCredit,
      expiryDate,
      totalCredits,
      appointmentCategory,
      itemList,
      isFirstSchedule,
      professionalName,
    } = this.state;

    return (
      <div className="CheckoutPlans">
        <div className="CheckoutPlans__header">
          <Row align='center' justify='center' margin='2rem 0 0.5rem'>
            <Typography
              align='center'
              style={{ width: '100%' }}
              type='title'>
              <Trans>Detalhes do agendamento</Trans>
            </Typography>
          </Row>

          <Row align='center' justify='center' margin='0 0 2.5rem'>
            <Typography
              align='center'
              color="grey-dark"
              style={{ width: '100%' }}
              type='paragraph'>
              <Trans>Passo 2 de 2</Trans>
            </Typography>
          </Row>
        </div>

        <div className="CheckoutPlans__content">
          <div className="Details">
            <Row>
              <Column colWidth={7} style={{ 'marginBottom': '2rem' }}>
                <Card classModifier="darkenBackground">
                  {/* OBS: não mudei o link de remover cart item porque 
                  não consigo  acessar a página de checkout normal, 
                  está quebrado, acredito que pela implementação dos planos. */}
                  <CartList
                    appointmentCategory={appointmentCategory}
                    isDeletable
                    itemList={itemList}
                    onDelete={this.handleDeleteItem}
                    professionalName={professionalName}
                  />
                </Card>
              </Column>

              <Column colWidth={5}>
                <Row direction="column">
                  <Row>
                    {
                      isFirstSchedule ? (
                        <Card classModifier="yellowBackground">
                          <Row margin='0 0 1.5rem'>
                            <Typography type="subtitle">
                              <Trans>Importante:</Trans>
                            </Typography>
                          </Row>

                          <Typography>
                            <Trans>
                              Seu plano autorizou a primeira consulta de avaliação.
                              Ao término dela, o profissional encaminhará o pedido
                              médico para autorização das demais sessões.
                            </Trans>
                          </Typography>
                        </Card>) : (
                        <CartPlansCredit
                          currentCredit={currentCredit}
                          expiryDate={expiryDate}
                          totalCredits={totalCredits}
                        />)
                    }
                  </Row>

                  <Row margin="20px 0 0">
                    <Button
                      id="cart-submit"
                      onButtonClick={this.handleSubmit}
                      text={(<Trans>Finalizar agendamento</Trans>)}
                    />
                  </Row>
                </Row>
              </Column>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

export default (Details);